import { render, staticRenderFns } from "./InviteConsumers.vue?vue&type=template&id=0bd9ec97&"
import script from "./InviteConsumers.vue?vue&type=script&lang=js&"
export * from "./InviteConsumers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports